import DatePickerMulti from 'components/date-picker/date-picker-multi/DatePickerMulti';
import { FormField } from 'components/form';
import React from 'react';
import { getDisplayDateRange } from 'utils/date';
import './entertainment-video-timeframe.scss';
import { PUBLISHED_DATES_FORMAT } from 'modules/entertainment-videos/constants';
import moment from 'moment';

const getMaxAllowedPublishedUntilDate = () => moment().add(2, 'years').subtract(1, 'day');

export function EntertainmentVideoTimeframe({
  isEditMode = false,
  publishedFrom,
  publishedUntil,
  onTimeframeChange
}: {
  isEditMode?: boolean,
  publishedFrom?: string | null,
  publishedUntil?: string | null,
  onTimeframeChange?: (from: string | null, until: string | null) => void
}) {
  if (isEditMode) {
    return (
      <FormField
        direction="column"
        showRequiredMark={false}
        showValidationIcon={false}
      >
        <DatePickerMulti
          startDateName="entertainment-video-published-from"
          startDate={publishedFrom}
          endDateName="entertainment-video-published-until"
          endDate={publishedUntil}
          noPastDates
          maxAllowableDate={getMaxAllowedPublishedUntilDate().format(PUBLISHED_DATES_FORMAT)}
          onChange={(from, until) => {
            onTimeframeChange?.(from, until);
          }}
        />
      </FormField>
    );
  }

  if (!publishedFrom || !publishedUntil) {
    return <span>–</span>;
  }

  return (
    <div className="entertainment-video-timeframe">
      {getDisplayDateRange(publishedFrom, publishedUntil)}
    </div>
  );
}
